<div class="insights-container">
  <!-- One sub-tab per battery type -->
  <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
    <rb-tab-panel>
      <ng-container *ngFor="let tab of dynamicTabItems">
        <div *rbTabPanelItem="dynamicTab; details: tab; id: tab.slug" class="row sub-tab-content">

          <rb-loading-spinner *ngIf="tab.dataLoadingFleetStatus" class="spinner"></rb-loading-spinner>
          <div class="row ms-0 me-0 mt-1 mb-1 ps-0 pe-0" *ngIf="!tab.dataLoadingFleetStatus && tab.errorMessageFleetStatus">
            <rb-callout type="warning">
              No fleet data.
            </rb-callout>
          </div>

          <!-- Fleet Status -->
          <div class="row ms-0 me-0 mt-1 mb-1 ps-0 pe-0" *ngIf="!tab.dataLoadingFleetStatus && !tab.errorMessageFleetStatus"><!-- class="row ms-3 me-3 mt-1 mb-1 ps-0 pe-0" -->
            <div class="col-md-12 ps-1 pe-1" *ngFor="let info of tab.fleetStatus">
              <div *ngIf="info.statusText">
                <div class="fleetStatusGreen p-2" *ngIf="info.statusCode == 1">
                  <strong>{{info.splittedText?.[0] ?? ''}}</strong>
                  <h4 class="m-0">{{info.splittedText?.[1] ?? ''}}.</h4>
                  <p>Analyzed time period starting from: <strong><span [innerHTML]="formatDateWithNbsp(info.fleetTimeWindowsStart)"></span></strong> - <strong><span [innerHTML]="formatDateWithNbsp(info.fleetTimeWindowsEnd)"></span></strong></p>
                </div>
                <div class="fleetStatusGreen p-2" *ngIf="info.statusCode == 2">
                  <strong>{{info.splittedText?.[0]}}</strong>
                  <h4 class="m-0">{{info.splittedText?.[1] ?? ''}}.</h4>
                  <p>Analyzed time period starting from: <strong><span [innerHTML]="formatDateWithNbsp(info.fleetTimeWindowsStart)"></span></strong> - <strong><span [innerHTML]="formatDateWithNbsp(info.fleetTimeWindowsEnd)"></span></strong></p>
                </div>
                <div class="fleetStatusYellow p-2" *ngIf="info.statusCode == 3">
                  <strong>{{info.splittedText?.[0]}}</strong>
                  <h4 class="m-0">{{info.splittedText?.[1] ?? ''}}.</h4>
                  <p>Analyzed time period starting from: <strong><span [innerHTML]="formatDateWithNbsp(info.fleetTimeWindowsStart)"></span></strong> - <strong><span [innerHTML]="formatDateWithNbsp(info.fleetTimeWindowsEnd)"></span></strong></p>
                </div>
              </div>
            </div>
          </div>

          <div class="row ms-0 me-0 mt-1 mb-1 ps-0 pe-0"> <!-- class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0" -->
            <div class="col-md-6 ps-0 pe-0">
              <app-battery-condition-chart *ngIf="fleetId.length > 0" [fleetId]="fleetId" [chartId]="'battery-condition-chart-' + tab.slug" [dataLoadingBCEvents]="tab.dataLoadingBCEvents" [errorMessageBCEvents]="tab.errorMessageBCEvents" [batteryConditions]="tab.batteryConditions"></app-battery-condition-chart>
            </div>
            <div class="col-md-6 ps-0 pe-0">
              <app-battery-condition-predicted-chart *ngIf="fleetId.length > 0" [fleetId]="fleetId" [chartId]="'battery-condition-predicted-chart-' + tab.slug" [dataLoadingBCEvents]="tab.dataLoadingBCEvents" [errorMessageBCEvents]="tab.errorMessageBCEvents" [batteryConditions]="tab.batteryConditions" [fleetStatus]="tab.fleetStatus"></app-battery-condition-predicted-chart>
            </div>
            <!-- <div class="col-md-4 ps-0 pe-0">
              <app-stress-factors-fleet *ngIf="fleetId.length > 0" [fleetId]="fleetId" [batteryType]="tab.filter" [chartId]="'stress-factors-fleet-' + tab.slug"></app-stress-factors-fleet>
            </div> -->
          </div>

          <hr class="ms-2 me-2 mt-1 mb-1 ps-0 pe-0">

          <app-atomic-aging [fleetId]="fleetId" [batteryType]="tab.filter" [companyData]="companyData" [isMetric]="isMetric"></app-atomic-aging>

          <hr class="ms-2 me-2 mt-1 mb-1 ps-0 pe-0">

          <app-vehicle-of-note [fleetId]="fleetId" [batteryType]="tab.filter"></app-vehicle-of-note>

        </div>
      </ng-container>
    </rb-tab-panel>
  </div>

  <hr class="ms-2 me-2 mt-1 mb-1 ps-0 pe-0">

  <!-- Charts below compare every selected battery type within the same view -->
  <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
    <div class="col-md-6 ps-0 pe-0">
      <div class="chart-spacer"></div>
      <app-ev-battery-condition-chart *ngIf="fleetId.length > 0" [fleetId]="fleetId" [selectedBatteryTypes]="selectedBatteryTypes" [companyData]="companyData" [isMetric]="isMetric"></app-ev-battery-condition-chart>
    </div>
    <div class="col-md-6 ps-0 pe-0">
      <div class="d-flex justify-content-center">
        <rb-form-switch
          [checked]="switch.checked"
          [disabled]="switch.disabled"
          (change)="switchChange($event)">
          Predicted SoH
        </rb-form-switch>
      </div>
      <div *ngIf="switchSoh; else predictedSoh">
        <app-predicted-sohc-chart *ngIf="fleetId.length > 0" [fleetId]="fleetId" [selectedBatteryTypes]="selectedBatteryTypes"></app-predicted-sohc-chart>
      </div>
      <ng-template #predictedSoh>
        <app-current-sohc-chart *ngIf="fleetId.length > 0" [fleetId]="fleetId" [selectedBatteryTypes]="selectedBatteryTypes"></app-current-sohc-chart>
      </ng-template>
    </div>
  </div>

  <hr class="ms-2 me-2 mt-1 mb-1 ps-0 pe-0">

  <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
    <div class="col-md-6 ps-0 pe-0">
      <app-vehicle-mileage-chart *ngIf="fleetId.length > 0" [fleetId]="fleetId" [selectedBatteryTypes]="selectedBatteryTypes" [companyData]="companyData" [isMetric]="isMetric"></app-vehicle-mileage-chart>
    </div>
    <div class="col-md-6 ps-0 pe-0">
      <app-avg-fleet-efficiency-chart *ngIf="fleetId.length > 0" [fleetId]="fleetId" [selectedBatteryTypes]="selectedBatteryTypes" [companyData]="companyData" [isMetric]="isMetric"></app-avg-fleet-efficiency-chart>
    </div>
  </div>

  <ng-template #dynamicTab let-details="details">
    <div title="{{ details.label }}">
      {{ details.label.length > 40 ? (details.label | slice:0:40) + '...' : details.label }}
    </div>
  </ng-template>
</div>
